import React, { useState, useEffect } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import ModalUpload from '../controls/ModalUpload';
import ModalSelectDocument from '../controls/ModalSelectDocument';
import Tools from '../tools/tools';
import ModalMail from '../controls/ModalMail';
import ModalMailShow from '../controls/ModalMailShow';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import request from '../reducers/request';


const RequestActivities = (props) => {
    let [jobTypes, setJobTypes] = useState();
    let [jobTypeId, setJobTypeId] = useState();
    let [afterJobId, setAfterJobId] = useState();
    let [newJob, setNewJob] = useState();
    let [jobs, setJobs] = useState();

    const requestId = sessionStorage.getItem("requestId");
    

    const fetchData = async () => {
        if (!requestId) {
            return;
        }

        setJobTypes(null);
        setJobTypeId(0);
        Comm.Instance().get(`jobtype`).then(result => {
            setJobTypes(result.data).catch(error => Tools.ProcessError(error));

        }).catch(message => {


        })

        setJobs(null);
        setAfterJobId(0);Comm.Instance().get(`job?requestId=${requestId}`).then(result => {
            setJobs(result.data);

        }).catch(error => Tools.ProcessError(error))
    };
    useEffect(() => {

        fetchData();
    }, []);

    const newActivity = () => {
        let data = {
            requestId: parseInt(requestId),
            jobTypeId: parseInt(jobTypeId),
            afterJobId: parseInt(afterJobId)
        }
        Comm.Instance().post("Job", data).then(r => setNewJob(r.data)).catch(error => Tools.ProcessError(error));
    };

    if (!requestId) {
        return (<Redirect to="/MyJobs" />);
    }


    if (!jobTypes || !jobs)
        return (
            <div className="container">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!jobTypes}
                />
            </div>
        );

    if (newJob) {
        return (<Redirect to={"RequestJob/" + newJob} />);
    }

    return (
        <>
            <div className="container">

                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Тип дейност</label>
                        <select className="form-control" value={jobTypeId} onChange={(e) => setJobTypeId(e.target.value)}>
                            <option value="0"></option>
                            {
                                jobTypes.map(i => <option value={i.jobTypeId}>{i.title}</option>)
                            }
                        </select>

                    </div>
                </div>
                <div className="form-row">
                    <div className="form-group col-md-12">
                        <label>Предхождаща задача</label>
                        <select className="form-control" value={afterJobId} onChange={(e) => setAfterJobId(e.target.value)}>
                            <option value="0"></option>
                            {
                                jobs.map(i => <option value={i.jobId}>{i.name}</option>)
                            }
                        </select>

                    </div>
                </div>
            </div>

            <div className="container">
                {
                    jobTypeId != "0" ?
                        <button type="button" className="btn btn-primary" onClick={() => newActivity()}>Новa дейност</button>
                        : null
                }
            </div>

        </>

    );
}


export default RequestActivities;

